import * as React from 'react';
import classNames from 'classnames';

type Cols = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface ColumnProps {
  id?: string;
  xs?: Cols;
  sm?: Cols;
  md?: Cols;
  lg?: Cols;
  children?: React.ReactNode;
  className?: string;
}

const Column: React.FunctionComponent<ColumnProps &
  React.HTMLAttributes<HTMLDivElement>> = (props: ColumnProps) => {
  const { id, xs, sm, md, lg, children, className } = props;

  const columnClass = classNames(className, {
    [`ui-grid-col--xs-${xs}`]: xs,
    [`ui-grid-col--sm-${sm}`]: sm,
    [`ui-grid-col--md-${md}`]: md,
    [`ui-grid-col--lg-${lg}`]: lg,
  });

  return (
    <div id={id} className={columnClass}>
      {children}
    </div>
  );
};

export default Column;
